import { CssBaseline } from "@mui/material";
import {
  AccountButton,
  AuthProvider,
  Navbar,
  type OidcUser,
} from "@ssf/auth-components";
import {
  AppContainer,
  AppWrapper,
  clubTheme,
  Footer,
  Page,
  queryClient,
} from "@ssf/components";
import { setAuthorization as setMemdbAuthorization } from "@ssf/memdb-api";
import { QueryClientProvider } from "@tanstack/react-query";
import { Header, HeaderMenu, Router, TornetChat } from "./components/index.js";
import { i18next, routes, setAuthorization } from "./lib/index.js";

const SIGNIN_REDIRECT_ARGS = { extraQueryParams: { createAccount: true } };
const SIGNOUT_REDIRECT_ARGS = { state: { returnTo: routes.signedOut } };
const onUser = (user: OidcUser | null | undefined) => {
  setMemdbAuthorization(user?.access_token);
  setAuthorization(user?.access_token);
};

export const App = () => (
  <AppWrapper env={import.meta.env} theme={clubTheme} i18n={i18next}>
    <CssBaseline />
    <QueryClientProvider client={queryClient}>
      <AuthProvider
        signinRedirectArgs={SIGNIN_REDIRECT_ARGS}
        signoutRedirectArgs={SIGNOUT_REDIRECT_ARGS}
        redirectOnSilentFailure={false}
        onUser={onUser}
      >
        <Page>
          <Navbar renderHeader={(props) => <Header {...props} />}>
            <AccountButton />
            <HeaderMenu />
          </Navbar>
          <AppContainer>
            <Router />
          </AppContainer>
          <Footer />
          {process.env.MODE !== "production" && <TornetChat />}
        </Page>
      </AuthProvider>
    </QueryClientProvider>
  </AppWrapper>
);
